// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"443":"6e30ddea","512":"bab3e4d5","725":"af04d8dc"}[chunkId] + ".chunk.css";
};